import $ from 'jquery';
import { bindEventsSubscription } from '~/subscribtion.js';

$(() => {
	$(document).on('click', '.more-button', function () {
		const { url } = this.dataset;
		const $divWithButton = $(this).parent('.category-products__more');
		const $divWithPagination = $('.category-products__pagination');

		if (url) {
			$.get(url)
				.done((data) => {
					$divWithButton.replaceWith(data);
					$divWithPagination.remove();
					const newProducts = document.querySelectorAll(".product-list__item");
					newProducts.forEach((product) => bindEventsSubscription(product));
				});
		}
	});
});
